import { render } from "./LeaguePage.vue?vue&type=template&id=5670c65c&scoped=true"
import script from "./LeaguePage.vue?vue&type=script&lang=js"
export * from "./LeaguePage.vue?vue&type=script&lang=js"

import "./LeaguePage.vue?vue&type=style&index=0&id=5670c65c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5670c65c"]])

export default __exports__